import { FC, useState } from 'react';

import { StyPrivacity, StyTerms } from '~/modules/signup/pages/styles';
import { TermsModal } from '~/modules/signup/pages/Modals/termsModal';
import { PoliticasModal } from '~/modules/signup/pages/Modals/politicasModal';

import { Typography } from '~/common/components/Typography';
import { Modal } from '~/common/components/Modal';
import { Checkbox } from '~/common/components/Form/Checkbox';
import { Button } from '~/common/components/Button';

interface IConfirmTermsModal {
  open: boolean;
  close: () => void;
}

export const ConfirmTermsModal: FC<IConfirmTermsModal> = ({ open, close }) => {
  const [termsAccepted, setTermsAccepted] = useState<boolean>(false);
  const [openTerms, setOpenTerms] = useState<boolean>(false);
  const [openPoliticas, setOpenPoliticas] = useState<boolean>(false);

  return (
    <Modal
      id="aceite-os-termos-modal"
      isOpen={open}
      onClose={close}
      height="200px"
      width="400px"
      hasCloseButton={false}
      title="Aceite os termos de uso e políticas de privacidade"
    >
      <PoliticasModal
        open={openPoliticas}
        close={() => setOpenPoliticas(false)}
      />
      <TermsModal open={openTerms} close={() => setOpenTerms(false)} />
      <StyTerms>
        <Checkbox
          onToggle={() => {
            setTermsAccepted(!termsAccepted);
          }}
          isChecked={termsAccepted}
        />
        <Typography.Label size="x-small" color="neutral.500">
          Eu aceito os
        </Typography.Label>
        <StyPrivacity onClick={() => setOpenTerms(true)}>
          <Typography.Label size="x-small" color="green.500">
            termos de uso
          </Typography.Label>
        </StyPrivacity>
        <Typography.Label size="x-small" color="neutral.500">
          e
        </Typography.Label>
        <StyPrivacity onClick={() => setOpenPoliticas(true)}>
          <Typography.Label size="x-small" color="green.500">
            políticas de privacidade
          </Typography.Label>
        </StyPrivacity>
      </StyTerms>

      <Button
        disabled={!termsAccepted}
        text="Fechar"
        width="100%"
        justifyContent="center"
        onClick={close}
      />
    </Modal>
  );
};
